import React, { ReactNode } from 'react'
import cn from 'classnames'
import css from './tab.module.less'

export type TabProps = {
  className?: string
  options: { label: string; value: string }[]
  value: string
  onChange: (value: string) => void
  children?: ReactNode
}
export default function Tab({ className, options, value, onChange, children }: TabProps) {
  return (
    <div className={cn(css.tab, className)}>
      <nav className={css.options}>
        {options.map((option) => (
          <a
            key={option.value}
            className={cn(css.item, { [css.active]: value === option.value })}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </a>
        ))}
      </nav>
      {children}
    </div>
  )
}
